'use client';

import { usePathname } from 'next/navigation';

import { useQuantaLogin } from '@/hooks/api/quanta/useQuantaLogin';
import { useQuantaCheck } from '@/hooks/api/quanta/useQuantaCheck';
import { getIsQuantaPage } from '@/components/layout/utils';
import { cn } from '@/utils/cn';

import useRedirect from './hooks/useRedirect';
// import QuantaBg from './components/QuantaBg';
import PointsRankingCard from './components/PointsRankingCard';
import ProgressCard from './components/ProgressCard';
import { getMaxPointsForLevel, LEVELS } from './utils';

interface QuantaLayoutProps {
  children: React.ReactNode;
}

const QuantaLayout: React.FC<QuantaLayoutProps> = ({ children }: QuantaLayoutProps) => {
  const pathname = usePathname();
  const { data: checkData } = useQuantaCheck();
  const { data: loginData } = useQuantaLogin({ enabled: !!checkData?.data.isRegistered });

  useRedirect(!loginData);

  const totalPoints = loginData?.data.points_total ?? 0;
  const levelResponse = loginData?.data.user.level || 1;
  const levelsResponse = loginData?.data.levels ?? null;

  const maxPoints = getMaxPointsForLevel(levelResponse, levelsResponse);
  const isLevelUp = totalPoints >= maxPoints;

  return (
    <div key={loginData?.data.user.user_id} className={cn(!!loginData && 'flex flex-1')}>
      {/* <QuantaBg isShown={!!loginData}> */}
      <div className={cn(!!loginData && 'flex flex-1 flex-col gap-4 p-4 3xl:p-8')}>
        {!getIsQuantaPage(pathname) && !!loginData && (
          <div className={cn('flex justify-between gap-4', isLevelUp ? 'items-start' : 'items-center')}>
            <PointsRankingCard totalPoints={totalPoints} ranking={loginData.data.ranking} width={300} />
            <ProgressCard
              isLevelUp={isLevelUp}
              status={LEVELS[levelResponse]?.title}
              level={levelResponse}
              totalPoints={totalPoints}
              maxPoints={maxPoints}
            />
          </div>
        )}
        {children}
      </div>
      {/* </QuantaBg> */}
    </div>
  );
};

export default QuantaLayout;
